var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHot = function SvgHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Hot deal"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2839"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2740"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf31",
    fillRule: "evenodd",
    d: "m11.113 46.737-.055.768c-.055.764-.11 1.525-.11 2.344a29.337 29.337 0 0 0 29.048 29.549A29.34 29.34 0 0 0 69.051 49.85c0-.559 0-1.119-.035-1.675-.473-16.769-8.6-20.973-8.944-21.143a1.57 1.57 0 0 0-1.462.028 1.65 1.65 0 0 0-.843 1.217c-.012.11-1.505 10.126-8.085 11.552a74 74 0 0 0-1.663-16.651A41.8 41.8 0 0 0 32.858.906 1.58 1.58 0 0 0 31.184.78a1.66 1.66 0 0 0-.879 1.462c0 7.667-3.794 12.86-8.187 18.881-4.74 6.5-10.118 13.861-11 25.615m38.564 18.884a10.13 10.13 0 0 1-9.686 10.493 10.13 10.13 0 0 1-9.685-10.492c0-.3.02-.587.043-.871a18.85 18.85 0 0 1 4.142-10.249 21.3 21.3 0 0 0 3.317-6.21 16 16 0 0 1 3.27 6.292 33.5 33.5 0 0 1 .613 7.471 1.63 1.63 0 0 0 1.615 1.642 5.91 5.91 0 0 0 5.331-3.924 13.5 13.5 0 0 1 1.02 5.213c.012.221.012.406.008.583Z",
    "data-name": "Path 6080"
  }))))));
};
export default SvgHot;